import { useEffect, useState } from 'react';
import { Volume2, Square } from 'lucide-react';
import { toast } from 'sonner';
import { playTts, stopTts, onPlayer, ttsFind, TTS_LANGS } from '../lib/helpAudio';

// read aloud / stop for one help text (stored recording in the app language; text stays readable without audio)
export default function SpeakBtn({ t, id, lang, text, hash, testid }) {
  const [cur, setCur] = useState(null);
  const [h, setH] = useState(hash || null);
  useEffect(() => onPlayer(setCur), []);
  useEffect(() => { if (hash) return undefined; let a = true; ttsFind(lang, text).then((x) => a && setH(x)); return () => { a = false; }; }, [lang, text, hash]);
  if (!TTS_LANGS.includes(lang)) return null;
  const on = cur === id;
  const click = (e) => {
    e.preventDefault(); e.stopPropagation();
    if (on) return stopTts();
    return playTts(id, h, () => toast.message(t.ttsNone, { id: 'tts-none' }));
  };
  return (
    <button type="button" className={`speak-btn ${on ? 'on' : ''}`} data-testid={testid || `speak-${id}`} aria-label={on ? t.ttsStop : t.ttsPlay} title={on ? t.ttsStop : t.ttsPlay} aria-pressed={on} onClick={click}>
      {on ? <Square size={13} /> : <Volume2 size={14} />}<span>{on ? t.ttsStop : t.ttsPlay}</span>
    </button>
  );
}
